import { Tab } from '@headlessui/react'
import className from 'classnames'
import { useRouter } from 'next/router'

import badgeImg from '@/assets/fee icons/SVG/badge.svg'
import cubeImg from '@/assets/fee icons/SVG/cube.svg'
import grpChatImg from '@/assets/fee icons/SVG/grpChat.svg'
import infinityImg from '@/assets/fee icons/SVG/infinity.svg'
import notebookImg from '@/assets/fee icons/SVG/notebook.svg'
import targetBoardImg from '@/assets/fee icons/SVG/targetBoard.svg'
import todoImg from '@/assets/fee icons/SVG/todo.svg'
import videoImg from '@/assets/fee icons/SVG/video.svg'

const data = {
  '0eacbba2-c69c-42eb-9eca-085e64b27f4f': [
    { title: 'Prioritise to be stress free' },
    { liveSessions: '4' },
    { videos: '38' },
    { videoLength: '80' },
    { games: '3' },
    { quizes: '6' },
    { assessments: '2' },
    { assistJrnl: '10' },
  ],
  '6f9d5445-8093-45a4-b81f-50f007b1ef56': [
    { title: 'Enhancing self esteem' },
    { liveSessions: '4' },
    { videos: '43' },
    { videoLength: '83' },
    { games: '5' },
    { quizes: '9' },
    { assessments: '3' },
    { assistJrnl: '6' },
  ],
  'b515d2f9-89a2-4295-8658-916350959dee': [
    { title: 'Increasing Resilience' },
    { liveSessions: '4' },
    { videos: '38' },
    { videoLength: '88' },
    { games: '4' },
    { quizes: '4' },
    { assessments: '4' },
    { assistJrnl: '8' },
  ],
}

const CourseFee = () => {
  const router = useRouter()
  // For checking page route
  // console.log(router.query.handle, 'router')

  return (
    <Tab.Panel className='pt-10 font-light'>
      <div className='custom-font-24 mb-10 font-light'>
        <h3>Course Fee: Rs 1999</h3>{' '}
      </div>
      <div>
        <p className='mb-2.5 text-sm md:text-2xl'>This course includes:</p>
        <ul className='text-normal text-gray-500 md:text-2xl'>
          <li className='flex flex-wrap items-center py-[5px]'>
            <img
              src={`${videoImg.src}`}
              alt=''
              className='color-red mr-5 h-[40px] w-[40px]'
            />
            <p>
              {data[router.query.handle].map((el) => (
                <span key={el.videoLength}>{el.videoLength}</span>
              ))}{' '}
              minutes of{' '}
              {data[router.query.handle].map((el) => (
                <span key={el.videos}>{el.videos}</span>
              ))}{' '}
              on demand videos
            </p>
          </li>
          <li className='flex flex-wrap items-center py-[5px]'>
            <img
              src={`${cubeImg.src}`}
              alt=''
              className='mr-5 h-[40px] w-[40px]'
            />
            <p>
              {data[router.query.handle].map((el) => (
                <span key={el.quizes}>{el.quizes}</span>
              ))}{' '}
              quizes
            </p>
          </li>
          <li className='flex flex-wrap items-center py-[5px]'>
            <img
              src={`${todoImg.src}`}
              alt=''
              className='mr-5 h-[40px] w-[40px]'
            />
            <p>
              {data[router.query.handle].map((el) => (
                <span key={el.assessments}>{el.assessments}</span>
              ))}{' '}
              assessments
            </p>
          </li>
          <li className='flex flex-wrap items-center py-[5px]'>
            <img
              src={`${notebookImg.src}`}
              alt=''
              className='mr-5 h-[40px] w-[40px]'
            />
            <p>
              {data[router.query.handle].map((el) => (
                <span key={el.assistJrnl}>{el.assistJrnl}</span>
              ))}{' '}
              Assisted Journal
            </p>
          </li>
          <li className='flex flex-wrap items-center py-[5px]'>
            <img
              src={`${grpChatImg.src}`}
              alt=''
              className='mr-5 h-[40px] w-[40px]'
            />
            <p>
              {data[router.query.handle].map((el) => (
                <span key={el.liveSessions}>{el.liveSessions}</span>
              ))}{' '}
              live sessions
            </p>
          </li>
          {/* <li className='flex flex-wrap items-center py-[5px]'>
            <img
              src={`${targetBoardImg.src}`}
              alt=''
              className='mr-5 h-[40px] w-[40px]'
            />
            <p>Goal tracking</p>
          </li> */}
          <li className='flex flex-wrap items-center py-[5px]'>
            <img
              src={`${infinityImg.src}`}
              alt=''
              className='mr-5 h-[40px] w-[40px]'
            />
            <p>Full lifetime access</p>
          </li>
          <li className='flex flex-wrap items-center py-[5px]'>
            <img
              src={`${badgeImg.src}`}
              alt=''
              className='mr-5 h-[40px] w-[40px]'
            />
            <p>Certificate of completion</p>
          </li>
        </ul>
      </div>
    </Tab.Panel>
  )
}

export default CourseFee
